export const BankingTypes = {
    NotSet: 0,
    Case1_FasterPay_GBP: 1,
    Case2_IBAN: 2,
    Case3_BankCode: 3,
    Case4_Others: 4
};
